/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Or_Signup_EmailInputs */



/**
* | output |
* | --- |
* | "or sign up with email" |
*
* @param {Login_Or_Signup_EmailInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const login_or_signup_email = /** @type {((inputs?: Login_Or_Signup_EmailInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Or_Signup_EmailInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("ou s'inscrire avec email")
	if (locale === "es") return /** @type {LocalizedString} */ ("o registrarse con correo electrónico")
	if (locale === "pt") return /** @type {LocalizedString} */ ("ou cadastrar com e-mail")
	if (locale === "it") return /** @type {LocalizedString} */ ("oppure registrati con email")
	return /** @type {LocalizedString} */ ("or sign up with email")
});